import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
  standalone: false,
})
export class RedirectComponent implements OnInit {
  router = inject(Router);

  ngOnInit(): void {
    console.log('Redirect init');
    const savedRoute = localStorage.getItem('lastUrl');

    if (savedRoute) {
      this.router.navigate([savedRoute]);
    } else {
      this.router.navigate(['calendar']);
    }
  }
}
